import React, { useEffect, useState } from 'react'
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid,
  MenuItem,
  Select,
  TextField
} from '@mui/material'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker'
import { RoundedButton } from 'common/Button/Button'
import FormInputDetailsStack from 'common/Form/FormInputDetailsStack'
import TextColorFontBody from 'common/Typography/TextColorFontBody'

interface PaymentStatusDialogProps {
  handlePaymentStatusDialogClose: (value: void) => void
  paymentStatusDialog: boolean
  handleMenuClose: (value: void) => void
}

const PaymentStatusEditDialog = ({
  handlePaymentStatusDialogClose,
  paymentStatusDialog,
  handleMenuClose
}: PaymentStatusDialogProps) => {
  const [date, setDate] = useState<Date | null>()

  const handleChange = (newValue: Date | null) => {
    setDate(newValue)
  }

  useEffect(() => {
    const todayDate = new Date()
    setDate(todayDate)
  }, [])

  return (
    <Dialog
      open={paymentStatusDialog}
      onClose={() => {
        handlePaymentStatusDialogClose()
        handleMenuClose()
      }}
    >
      <DialogTitle>Payment Status</DialogTitle>
      <Divider sx={{ width: '100%' }} />
      <DialogContent>
        <DialogContentText sx={{ marginBottom: '24px' }}>
          {/* TO DO: INTEGRATE WITH BACKEND */}
          <TextColorFontBody sx={{ fontSize: '16px', fontWeight: 600 }}>
            Total amount due $4500
          </TextColorFontBody>
        </DialogContentText>
        <DialogContentText sx={{ display: 'flex', gap: '32px' }}>
          <FormInputDetailsStack formLabelHeader='Outstanding amount paid'>
            <TextField variant='standard' />
          </FormInputDetailsStack>
          <FormInputDetailsStack formLabelHeader='Payment Status'>
            <Select variant='standard'>
              <MenuItem>Paid</MenuItem>
              <MenuItem>Canceled</MenuItem>
              <MenuItem>Due</MenuItem>
            </Select>
          </FormInputDetailsStack>
          <FormInputDetailsStack formLabelHeader='Date'>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DesktopDatePicker
                inputFormat='dd/MM/yyyy'
                value={date}
                onChange={handleChange}
                renderInput={(params) => (
                  <TextField variant='standard' {...params} />
                )}
              />
            </LocalizationProvider>
          </FormInputDetailsStack>
        </DialogContentText>
      </DialogContent>
      <TextColorFontBody sx={{ marginLeft: '24px' }}>
        Payment Log
      </TextColorFontBody>

      <Box
        sx={{ backgroundColor: 'neutrals.background2', padding: '16px 24px' }}
      >
        {/* grid header */}
        <Grid container>
          <Grid item xs={2}>
            Amount
          </Grid>
          <Grid item xs={2}>
            Updated
          </Grid>
        </Grid>
        {/* TO DO: TO integrate amount */}
        <Grid container sx={{ marginTop: '16px' }}>
          <Grid item xs={2} sx={{ fontSize: '12px', color: 'neutrals.500' }}>
            $500
          </Grid>
          <Grid item xs={4} sx={{ fontSize: '12px', color: 'neutrals.500' }}>
            12 Dec 2022
          </Grid>
        </Grid>
      </Box>

      <DialogActions>
        <RoundedButton
          variant='filled'
          onClick={() => handlePaymentStatusDialogClose()}
        >
          Confirm
        </RoundedButton>
      </DialogActions>
    </Dialog>
  )
}

export default PaymentStatusEditDialog
